import { ImageLoaderCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss';

export class ToneMobileEvenCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '140px',
            borderRadius: "0px 25px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonemobileevencardimageloader.tsx